// Oshitabi Bundle - Auto-generated
(function() {
"use strict";

// === js/csv_loader.js ===
/**
 * CSV Loader Module
 * Handles loading and parsing of CSV files for Oshi-Tabi website
 * 
 * @requires PapaParse (https://www.papaparse.com/)
 */

// ============================================
// Configuration
// ============================================
const CSV_CONFIG = {
  CAMPAIGN_CSV: 'data/csv/data_1.csv',
  SLIDES_CSV: 'data/csv/slides.csv',
  HOLIDAY_CSV: 'data/csv/syukujitsu.csv',
  SKIP_ROWS: 4, // Rows 1-4 are headers/descriptions
  IMAGE_BASE_URL: 'data/image/',
  DEFAULT_IMAGE: 'dist/img/no_image.jpg' // Default thumbnail
};

/**
 * Generate timestamp version string (ddMMyyyyHHmmss)
 * Used for cache-busting on frequently updated CSV files
 * @returns {string} e.g. "10022026163200"
 */
function getTimestampVersion() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return pad(now.getDate())
    + pad(now.getMonth() + 1)
    + now.getFullYear()
    + pad(now.getHours())
    + pad(now.getMinutes())
    + pad(now.getSeconds());
}

// ============================================
// Cache
// ============================================
let campaignsCache = null;
let slidesCache = null;
let holidaysCache = null;

// ============================================
// Date Parsing
// ============================================

/**
 * Parse Japanese date format to Date object
 * Handles: "2025年1月15日", "2025年2月上旬", "2025年3月中旬", "2025年4月下旬"
 * 
 * @param {string} dateStr - Japanese date string
 * @returns {Date|null} Date object or null if empty/invalid
 */
function parseJapaneseDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') {
    return null;
  }

  const trimmed = dateStr.trim();
  if (trimmed === '') {
    return null;
  }

  // Patterns: 
  // 1. YYYY/M/D or YYYY-M-D
  // 2. YYYY年M月D日
  // 3. YYYY年M月上旬/中旬/下旬
  const slashPattern = /^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/;
  const fullPattern = /^(\d{4})年(\d{1,2})月(\d{1,2})日$/;
  const partialPattern = /^(\d{4})年(\d{1,2})月(上旬|中旬|下旬)$/;

  let match = trimmed.match(slashPattern);
  if (match) {
    return new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10));
  }

  match = trimmed.match(fullPattern);
  if (match) {
    return new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10));
  }

  match = trimmed.match(partialPattern);
  if (match) {
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const period = match[3];

    // 上旬 = 10日, 中旬 = 20日, 下旬 = 30日
    let day;
    switch (period) {
      case '上旬':
        day = 10;
        break;
      case '中旬':
        day = 20;
        break;
      case '下旬':
        day = 30;
        break;
      default:
        day = 1;
    }

    return new Date(year, month, day);
  }

  console.warn('Could not parse date:', dateStr);
  return null;
}

// ============================================
// CSV Loading
// ============================================

/**
 * Load and parse a CSV file with robust row stitching for malformed rows (unquoted newlines)
 * 
 * @param {string} url - URL of the CSV file
 * @returns {Promise<Array>} Array of objects
 */
async function loadCSV(url) {
  return new Promise((resolve, reject) => {
    Papa.parse(url, {
      download: true,
      header: false, // Parse as raw arrays to allow manual row stitching
      skipEmptyLines: true,
      complete: function(results) {
        if (results.errors && results.errors.length > 0) {
          console.warn('CSV parsing warnings:', results.errors);
        }

        const rawData = results.data;
        if (!rawData || rawData.length === 0) {
          resolve([]);
          return;
        }

        // 1. Identify the header row (first row with 'id' column)
        // This makes the loader resilient to added/removed description rows at the top
        let headerRowIdx = -1;
        for (let i = 0; i < Math.min(rawData.length, 10); i++) {
          let firstCol = String(rawData[i][0] || '').trim();
          // Remove BOM if present
          if (firstCol.startsWith('\uFEFF')) {
            firstCol = firstCol.substring(1);
          }
          if (firstCol.toLowerCase() === 'id' || firstCol === '管理ID') {
            headerRowIdx = i;
            break;
          }
        }

        // Fallback to row 0 if no clear header found
        if (headerRowIdx === -1) {
          headerRowIdx = 0;
        }

        const headers = rawData[headerRowIdx].map((h, i) => {
          let cleaned = String(h || '').trim();
          // Remove BOM from the very first header if it exists
          if (i === 0 && cleaned.startsWith('\uFEFF')) {
            cleaned = cleaned.substring(1);
          }
          return cleaned;
        });
        const expectedCols = headers.length;
        const dataRows = rawData.slice(headerRowIdx + 1);

        // 2. Stitch broken rows (unquoted newlines)
        // If a row has fewer columns than the header, it's likely split into multiple lines
        const stitchedRows = [];
        let pendingRow = null;

        for (const row of dataRows) {
          if (pendingRow) {
            // Append current row to pendingRow
            const lastIdx = pendingRow.length - 1;
            // Join with newline at the split point
            pendingRow[lastIdx] = (pendingRow[lastIdx] || '') + '\n' + (row[0] || '');
            // Push the rest of the columns
            if (row.length > 1) {
              pendingRow.push(...row.slice(1));
            }

            // If we now have enough columns (or more), it's a complete row
            if (pendingRow.length >= expectedCols) {
              stitchedRows.push(pendingRow.slice(0, expectedCols));
              pendingRow = null;
            }
          } else {
            // Detect split row: less columns than expected AND not a clearly new row
            // (heuristic: description rows that don't start with a valid-looking ID)
            if (row.length < expectedCols && row.length > 0) {
              pendingRow = [...row];
            } else {
              stitchedRows.push(row);
            }
          }
        }

        // Add final pending if it never got completed
        if (pendingRow) stitchedRows.push(pendingRow);

        // 3. Map to objects using headers
        const objects = stitchedRows.map(row => {
          const obj = {};
          headers.forEach((h, i) => {
            if (h) {
              const val = row[i];
              // Primary column name mapping if needed, otherwise use raw header
              obj[h] = (val !== undefined && val !== null) ? String(val).trim() : '';
            }
          });
          return obj;
        });

        resolve(objects);
      },
      error: function(error) {
        console.error('CSV loading error:', error);
        reject(error);
      }
    });
  });
}

// ============================================
// Campaign Data
// ============================================

/**
 * Transform raw CSV row to campaign object
 * 
 * @param {Object} row - Raw CSV row
 * @returns {Object} Campaign object
 */
function transformCampaign(row) {
  if (row.past_fix === '固定する') console.log(`FIXED ITEM FOUND: ${row.id}, title: ${row.title}`);
  return {
    id: row.id || '',
    title: row.title || '',
    linkUrl: row.link_url || '',
    start: parseJapaneseDate(row.start),
    finish: parseJapaneseDate(row.finish),
    // Use img column if available, otherwise try img_link or img_view as fallback
    img: row.img || row.img_link || row.img_view || '',
    keywords: row.keywords ? row.keywords.split(',').map(k => k.trim()).filter(k => k) : [],
    keywords_kana_hira: row['keywords_kana-hira'] ? row['keywords_kana-hira'].split(',').map(k => k.trim()).filter(k => k) : [],
    keywords_hira_kana: row['keywords_hira-kana'] ? row['keywords_hira-kana'].split(',').map(k => k.trim()).filter(k => k) : [],
    title_kana_hira: row['title_kana-hira'] || '',
    title_hira_kana: row['title_hira-kana'] || '',
    genres: {
      anime: row.genre_1 === '1' || (row.genre_all && (row.genre_all.includes('アニメ') || row.genre_all.includes('ゲーム') || row.genre_all.includes('漫画') || row.genre_all.includes('VTuber'))),
      artist: row.genre_2 === '1' || (row.genre_all && (row.genre_all.includes('アーティスト') || row.genre_all.includes('アイドル'))),
      media: row.genre_3 === '1' || (row.genre_all && (row.genre_all.includes('メディア') || row.genre_all.includes('テレビ') || row.genre_all.includes('ラジオ') || row.genre_all.includes('雑誌'))),
      other: row.genre_4 === '1' || (row.genre_all && row.genre_all.includes('その他'))
    },
    fix: row.fix === '1' || row.fix === '上位固定' || row.fix === '固定する',
    fixSortNo: parseInt(row.fix_sort || row.fix_sortNo || '999', 10),
    pastFix: row.past_fix === '1' || row.past_fix === '上位固定' || row.past_fix === '固定する',
    pastFixSortNo: parseInt(row.past_fix_sortNo || '999', 10),
    display: row.display === '1' || row.display === '表示'
  };
}

/**
 * Get all campaigns (with caching)
 * 
 * @param {boolean} forceReload - Force reload from CSV
 * @returns {Promise<Array>} Array of campaign objects
 */
async function getCampaigns(forceReload = false) {
  if (campaignsCache && !forceReload) {
    return campaignsCache;
  }

  try {
    const csvUrl = CSV_CONFIG.CAMPAIGN_CSV + '?v=' + getTimestampVersion();
    const rawData = await loadCSV(csvUrl);
    
    campaignsCache = rawData
      .filter(row => {
        // Filter out empty rows or description rows
        // Description rows usually have Japanese labels in the ID column
        // Genuine IDs are usually alphanumeric (e.g., '3dyfi7yb4ho')
        if (!row.id || row.id.trim() === '') return false;
        
        const id = row.id.trim();
        // Skip common description labels
        const skipIds = ['管理ID', 'ユニークなID（5桁推奨）', '管理ID ', 'ユニークなID'];
        if (skipIds.includes(id)) return false;
        
        return true;
      })
      .map(transformCampaign)
      .filter(c => c.id && c.title); // Final safety check

    console.log(`Loaded ${campaignsCache.length} campaigns`);

    // Build search index asynchronously (non-blocking)
    buildSearchIndexAsync(campaignsCache);

    return campaignsCache;
  } catch (error) {
    console.error('Failed to load campaigns:', error);
    return [];
  }
}

/**
 * Build search index asynchronously using requestIdleCallback or setTimeout fallback.
 * This pre-normalizes title and keywords for each campaign to enable fast multi-keyword search.
 * Runs in the background without blocking the main render thread.
 * 
 * @param {Array} campaigns - Array of campaign objects
 */
function buildSearchIndexAsync(campaigns) {
  const buildIndex = () => {
    console.log('Building search index in background...');
    const startTime = performance.now();

    campaigns.forEach(campaign => {
      // Combine title and keywords into a single searchable string
      const searchableText = [
        campaign.title || '',
        campaign.title_kana_hira || '',
        campaign.title_hira_kana || '',
        ...(campaign.keywords || []),
        ...(campaign.keywords_kana_hira || []),
        ...(campaign.keywords_hira_kana || [])
      ].join(' ');

      // Normalize and store as _searchIndex for fast lookup
      campaign._searchIndex = normalizeForSearch(searchableText);
    });

    const endTime = performance.now();
    console.log(`Search index built in ${(endTime - startTime).toFixed(1)}ms for ${campaigns.length} campaigns`);
  };

  // Use requestIdleCallback if available (modern browsers), otherwise fall back to setTimeout
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(buildIndex, { timeout: 2000 });
  } else {
    setTimeout(buildIndex, 100); // Small delay to allow critical rendering to complete
  }
}

/**
 * Normalize text for search comparison
 * Converts to full-width and lowercase
 * 
 * @param {string} str - Input string
 * @returns {string} Normalized string for comparison
 */
function normalizeForSearch(str) {
  if (!str) return '';
  return normalizeToFullWidth(str).toLowerCase();
}

// ============================================
// Slide Data
// ============================================

/**
 * Transform raw CSV row to slide object
 * 
 * @param {Object} row - Raw CSV row
 * @returns {Object} Slide object
 */
function transformSlide(row) {
  return {
    id: row.id || '',
    linkUrl: row.link_url || '',
    img: row.img || '',
    sortOrder: parseInt(row.sort_order, 10) || 999,
    display: row.display === '1'
  };
}

/**
 * Get all slides (with caching)
 * 
 * @param {boolean} forceReload - Force reload from CSV
 * @returns {Promise<Array>} Array of slide objects
 */
async function getSlides(forceReload = false) {
  if (slidesCache && !forceReload) {
    return slidesCache;
  }

  try {
    const rawData = await loadCSV(CSV_CONFIG.SLIDES_CSV);
    slidesCache = rawData
      .map(transformSlide)
      .filter(s => s.id && s.img); // Filter out empty rows

    console.log(`Loaded ${slidesCache.length} slides`);
    return slidesCache;
  } catch (error) {
    console.error('Failed to load slides:', error);
    return [];
  }
}

// ============================================
// Holiday Data
// ============================================

/**
 * Get holidays (with caching)
 * Returns object mapping "YYYY/M/D" -> "Holiday Name"
 * 
 * @param {boolean} forceReload - Force reload from CSV
 * @returns {Promise<Object>} Object mapping date strings to holiday names
 */
async function getHolidays(forceReload = false) {
  if (holidaysCache && !forceReload) {
    return holidaysCache;
  }

  try {
    const response = await fetch(CSV_CONFIG.HOLIDAY_CSV);
    const buffer = await response.arrayBuffer();
    const decoder = new TextDecoder('shift-jis');
    const text = decoder.decode(buffer);

    // Simple manual parsing for Syukujitsu CSV (YYYY/MM/DD,Name)
    const holidays = {};
    const lines = text.split(/\r?\n/);
    
    // Skip header (usually row 1)
    for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;
        
        const parts = line.split(',');
        if (parts.length >= 2) {
            // Normalize date format to YYYY/M/D (remove leading zeros)
            const dateStr = parts[0].trim(); // e.g., 2025/1/1 or 2025/01/01
            const name = parts[1].trim();
            
            // Reformat to match calendar comparison (M and D without leading zeros)
            const dateObj = new Date(dateStr);
            if (!isNaN(dateObj)) {
                const key = `${dateObj.getFullYear()}/${dateObj.getMonth() + 1}/${dateObj.getDate()}`;
                holidays[key] = name;
            }
        }
    }

    holidaysCache = holidays;
    console.log(`Loaded ${Object.keys(holidays).length} holidays`);
    return holidaysCache;
  } catch (error) {
    console.error('Failed to load holidays:', error);
    return {};
  }
}

// ============================================
// Utilities
// ============================================

/**
 * Get full image URL from filename
 * 
 * @param {string} filename - Image filename
 * @returns {string} Full URL
 */
function getImageUrl(filename) {
  // Return default image if no filename provided
  if (!filename || filename.trim() === '') {
    return CSV_CONFIG.DEFAULT_IMAGE;
  }
  
  // If already a full URL, return as-is
  if (filename.startsWith('http://') || filename.startsWith('https://')) {
    return filename;
  }
  
  return CSV_CONFIG.IMAGE_BASE_URL + filename;
}

/**
 * Clear all caches (useful for testing)
 */
function clearCache() {
  campaignsCache = null;
  slidesCache = null;
  holidaysCache = null;
}

// ============================================
// Exports (for module pattern)
// ============================================
// These functions are available globally for non-module usage
window.CsvLoader = {
  parseJapaneseDate,
  getCampaigns,
  getSlides,
  getHolidays,
  getImageUrl,
  clearCache,
  CONFIG: CSV_CONFIG
};


// === js/campaign_utils.js ===
/**
 * Campaign Utilities Module
 * Handles campaign status determination, badges, and sorting
 * 
 * @requires csv_loader.js
 */

// ============================================
// Status Constants
// ============================================
const STATUS = {
  ONGOING: '実施中',
  UPCOMING: '実施予定',
  ENDED: '実施済み'
};

// ============================================
// Badge Constants
// ============================================
const BADGE = {
  NEW: { text: 'NEW!', cssClass: 'badge-new' },
  ENDING_SOON: { text: 'もうすぐ終了!', cssClass: 'badge-end' }
};

// Time constants
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// ============================================
// Status Determination
// ============================================

/**
 * Get current date object adjusted to JST (Japan Standard Time)
 * Returns a Date object where getHours(), getDate() etc return JST values
 * despite the browser's local timezone.
 * 
 * Logic:
 * 1. Get current UTC time
 * 2. Add 9 hours (JST offset)
 * 3. Construct a "Local" Date object using the JST components
 *    This allows direct comparison with other "Local" Date objects
 *    created from CSV strings (which are parsed as local dates but represent JST)
 */
function getCurrentJST() {
  const now = new Date();
  
  // 1. Get UTC time in ms
  // now.getTime() returns milliseconds since Unix Epoch (UTC)
  const utc = now.getTime();
  
  // 2. Add 9 hours (JST offset)
  const jstOffset = 9 * 60 * 60 * 1000;
  const jstTime = new Date(utc + jstOffset);

  // 3. Construct a local Date object that visually matches JST
  return new Date(
    jstTime.getUTCFullYear(),
    jstTime.getUTCMonth(),
    jstTime.getUTCDate(),
    jstTime.getUTCHours(),
    jstTime.getUTCMinutes(),
    jstTime.getUTCSeconds()
  );
}

/**
 * Get the start of day for a date (00:00:00)
 * 
 * @param {Date} date - Input date
 * @returns {Date} Date at start of day
 */
function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * Determine campaign status based on dates
 * 
 * @param {Object} campaign - Campaign object with start/finish dates
 * @param {Date} today - Current date (defaults to JST)
 * @returns {string} STATUS.ONGOING | STATUS.UPCOMING | STATUS.ENDED
 */
function getCampaignStatus(campaign, today = getCurrentJST()) {
  const todayStart = startOfDay(today);
  const startDate = campaign.start;
  const finishDate = campaign.finish; // null if ongoing indefinitely

  // No start date means invalid campaign
  if (!startDate) {
    console.warn('Campaign missing start date:', campaign.id);
    return STATUS.ENDED;
  }

  // Future start = upcoming
  if (startDate > todayStart) {
    return STATUS.UPCOMING;
  }

  // No finish date = ongoing indefinitely
  if (finishDate === null) {
    return STATUS.ONGOING;
  }

  // Past finish = ended
  if (todayStart > finishDate) {
    return STATUS.ENDED;
  }

  // Otherwise ongoing
  return STATUS.ONGOING;
}

// ============================================
// Badge Determination
// ============================================

/**
 * Determine if campaign should show a badge
 * 
 * @param {Object} campaign - Campaign object
 * @param {Date} today - Current date
 * @returns {Object|null} { text, cssClass } or null
 */
function getCampaignBadge(campaign, today = getCurrentJST()) {
  const status = getCampaignStatus(campaign, today);

  // Only ongoing campaigns can have badges
  if (status !== STATUS.ONGOING) {
    return null;
  }

  const todayStart = startOfDay(today);
  const startDate = campaign.start;
  const finishDate = campaign.finish;

  // Ending soon badge: within 1 week before finish (higher priority)
  if (finishDate) {
    const timeUntilFinish = finishDate.getTime() - todayStart.getTime();
    if (timeUntilFinish >= 0 && timeUntilFinish <= ONE_WEEK_MS) {
      return BADGE.ENDING_SOON;
    }
  }

  // NEW badge: from 7 days BEFORE start until start date
  // Since campaign is ONGOING (start <= today), we check if today is within first week
  if (startDate) {
    const timeSinceStart = todayStart.getTime() - startDate.getTime();
    // Show NEW if we're at or within 7 days after start (covers the "before start" spec for upcoming-to-ongoing transition)
    if (timeSinceStart >= 0 && timeSinceStart <= ONE_WEEK_MS) {
      return BADGE.NEW;
    }
  }

  return null;
}

// ============================================
// Sorting
// ============================================

/**
 * Sort campaigns by 3-tier priority:
 * 1. fix=1 (pinned) - sorted by Start Date
 * 2. NEW badge campaigns - sorted by Start Date
 * 3. Normal campaigns - sorted by Start Date
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {string} dateField - 'start' or 'finish'
 * @param {boolean} ascending - Sort direction
 * @param {boolean} useFix - Whether to prioritize fixed items (fix=1)
 * @returns {Array} Sorted array (new array, not mutated)
 */
function sortCampaigns(campaigns, dateField = 'start', ascending = true, useFix = true, usePastFix = false) {
  const today = getCurrentJST();
  
  if (usePastFix) {
    const pastFixed = campaigns.filter(c => c.pastFix);
    console.log(`Sorting with usePastFix=${usePastFix}. Found ${pastFixed.length} pastFixed items among ${campaigns.length} campaigns.`);
  }

  // Pre-calculate search-related data or badges if needed to avoid O(N log N) calculations
  // For badges, we cache the "isNew" status for each campaign in this sort run
  const newBadgeCache = new Map();
  campaigns.forEach(c => {
    newBadgeCache.set(c.id, getCampaignBadge(c, today)?.cssClass === 'badge-new');
  });

  return [...campaigns].sort((a, b) => {
    // Tier 0: Past Pinned items (pastFix=1) for Archives section
    if (usePastFix) {
      if (a.pastFix !== b.pastFix) {
        return a.pastFix ? -1 : 1;
      }
      if (a.pastFix && b.pastFix) {
        if (a.pastFixSortNo !== b.pastFixSortNo) {
          return a.pastFixSortNo - b.pastFixSortNo;
        }
      }
    }

    // Tier 1: Pinned items first (fix=1) for Ongoing/Upcoming sections
    if (useFix) {
      if (a.fix !== b.fix) {
        return a.fix ? -1 : 1;
      }
      if (a.fix && b.fix) {
        if (a.fixSortNo !== b.fixSortNo) {
          return a.fixSortNo - b.fixSortNo;
        }
      }
    }

    // Tier 2: NEW badge campaigns before normal ones
    const aIsNew = newBadgeCache.get(a.id);
    const bIsNew = newBadgeCache.get(b.id);
    if (aIsNew !== bIsNew) {
      return aIsNew ? -1 : 1;
    }

    // Tier 3: Sort by date within same tier
    const dateA = a[dateField] ? a[dateField].getTime() : (ascending ? 253402214400000 : -8640000000000000); // Max/Min date constants
    const dateB = b[dateField] ? b[dateField].getTime() : (ascending ? 253402214400000 : -8640000000000000);

    if (dateA !== dateB) {
      return ascending ? dateA - dateB : dateB - dateA;
    }
    
    return 0;
  });
}

// ============================================
// Grouping
// ============================================

/**
 * Group campaigns by status
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {Date} today - Current date
 * @returns {Object} { ongoing: [], upcoming: [], ended: [] }
 */
function groupByStatus(campaigns, today = getCurrentJST()) {
  const ongoing = [];
  const upcoming = [];
  const ended = [];

  for (const campaign of campaigns) {
    // Skip non-displayed campaigns
    if (!campaign.display) continue;

    const status = getCampaignStatus(campaign, today);
    switch (status) {
      case STATUS.ONGOING:
        ongoing.push(campaign);
        break;
      case STATUS.UPCOMING:
        upcoming.push(campaign);
        break;
      case STATUS.ENDED:
        ended.push(campaign);
        break;
    }
  }

  return {
    ongoing: sortCampaigns(ongoing, 'start', false, true),  // Descending: most recent start first. Pins ON.
    upcoming: sortCampaigns(upcoming, 'start', false, true), // Descending: most recent start first. Pins ON.
    ended: sortCampaigns(ended, 'start', false, false, true) // Descending: most recent start first. fix OFF, pastFix ON.
  };
}

// ============================================
// Date Formatting
// ============================================

/**
 * Format date to Japanese display format
 * 
 * @param {Date} date - Date object
 * @returns {string} Formatted string (e.g., "2025年12月19日")
 */
function formatDate(date) {
  if (!date) return '';
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}

/**
 * Format date range for display
 * 
 * @param {Date} start - Start date
 * @param {Date} finish - End date (can be null)
 * @param {string} status - Campaign status
 * @returns {string} Formatted date range
 */
function formatDateRange(start, finish, status) {
  const startStr = formatDate(start);

  if (finish) {
    return `${startStr}～${formatDate(finish)}`;
  }

  return `${startStr}～`;
}

// ============================================
// Exports
// ============================================
window.CampaignUtils = {
  STATUS,
  BADGE,
  getCurrentJST,
  getCampaignStatus,
  getCampaignBadge,
  sortCampaigns,
  groupByStatus,
  formatDate,
  formatDateRange
};

/**
 * Check if a URL is external (not in internal domains list)
 * Internal URLs: recommend.jr-central.co.jp, bud-jta.com, oshitabi, localhost, 127.0.0.1
 * Relative URLs (/, ./, ../) are always internal.
 * 
 * @param {string} url - URL to check
 * @returns {boolean} True if external
 */
function isExternalUrl(url) {
  if (!url || typeof url !== 'string') return false;
  
  const trimmed = url.trim();
  if (trimmed === '' || trimmed === '#') return false;
  
  // Relative paths are internal
  if (trimmed.startsWith('/') || trimmed.startsWith('./') || trimmed.startsWith('../')) {
    return false;
  }
  
  // Internal domains mapping (prefixes or full strings)
  const internalDomains = [
    'https://recommend.jr-central.co.jp',
    'http://recommend.jr-central.co.jp',
    'https://bud-jta.com',
    'http://bud-jta.com',
    'https://oshitabi',
    'http://oshitabi',
    'http://localhost',
    'http://127.0.0.1'
  ];
  
  // Check if URL starts with any internal domain
  for (const domain of internalDomains) {
    if (trimmed.startsWith(domain)) {
      return false;
    }
  }
  
  // If it has a protocol (http/https) but didn't match internal list, it's external
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return true;
  }
  
  // Default to internal for safety (e.g. mailto:, tel:, or unclear paths)
  return false;
}

// ============================================
// Exports
// ============================================
window.CampaignUtils = {
  STATUS,
  BADGE,
  getCurrentJST,
  getCampaignStatus,
  getCampaignBadge,
  sortCampaigns,
  groupByStatus,
  formatDate,
  formatDateRange,
  isExternalUrl
};


// === js/search_engine.js ===
/**
 * Search Engine Module
 * Handles keyword search, period search, genre filtering, and status filtering
 * 
 * @requires csv_loader.js
 * @requires campaign_utils.js
 */

// ============================================
// Character Normalization
// ============================================

// Half-width Katakana to Full-width mapping
const HALF_TO_FULL_KANA = {
  'ｦ': 'ヲ', 'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
  'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ', 'ｯ': 'ッ', 'ｰ': 'ー',
  'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
  'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
  'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
  'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
  'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
  'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
  'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
  'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
  'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
  'ﾜ': 'ワ', 'ﾝ': 'ン',
  'ﾞ': '゛', 'ﾟ': '゜'
};

// Dakuten (voiced) combinations
const DAKUTEN_MAP = {
  'カ': 'ガ', 'キ': 'ギ', 'ク': 'グ', 'ケ': 'ゲ', 'コ': 'ゴ',
  'サ': 'ザ', 'シ': 'ジ', 'ス': 'ズ', 'セ': 'ゼ', 'ソ': 'ゾ',
  'タ': 'ダ', 'チ': 'ヂ', 'ツ': 'ヅ', 'テ': 'デ', 'ト': 'ド',
  'ハ': 'バ', 'ヒ': 'ビ', 'フ': 'ブ', 'ヘ': 'ベ', 'ホ': 'ボ',
  'ウ': 'ヴ'
};

// Han-dakuten (semi-voiced) combinations
const HANDAKUTEN_MAP = {
  'ハ': 'パ', 'ヒ': 'ピ', 'フ': 'プ', 'ヘ': 'ペ', 'ホ': 'ポ'
};

/**
 * Convert half-width characters to full-width
 * Handles katakana, alphanumeric, and dakuten/handakuten combinations
 * 
 * @param {string} str - Input string
 * @returns {string} Normalized full-width string
 */
function normalizeToFullWidth(str) {
  if (!str) return '';

  let result = '';

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    const nextChar = str[i + 1];

    // Half-width Katakana
    if (HALF_TO_FULL_KANA[char]) {
      let fullChar = HALF_TO_FULL_KANA[char];

      // Check for dakuten (voiced mark) ﾞ
      if (nextChar === 'ﾞ' && DAKUTEN_MAP[fullChar]) {
        fullChar = DAKUTEN_MAP[fullChar];
        i++; // Skip next character
      }
      // Check for handakuten (semi-voiced mark) ﾟ
      else if (nextChar === 'ﾟ' && HANDAKUTEN_MAP[fullChar]) {
        fullChar = HANDAKUTEN_MAP[fullChar];
        i++;
      }

      result += fullChar;
    }
    // Half-width alphanumeric (ASCII 0x21-0x7E except space)
    else if (char.charCodeAt(0) >= 0x21 && char.charCodeAt(0) <= 0x7E) {
      // Convert to full-width equivalent (add 0xFEE0)
      result += String.fromCharCode(char.charCodeAt(0) + 0xFEE0);
    }
    // Half-width space → Full-width space
    else if (char === ' ') {
      result += '　'; // Full-width space U+3000
    }
    // Keep as-is (already full-width or other characters)
    else {
      result += char;
    }
  }

  return result;
}

/**
 * Normalize text for search comparison
 * Converts to full-width and lowercase
 * 
 * @param {string} str - Input string
 * @returns {string} Normalized string for comparison
 */
function normalizeForSearch(str) {
  if (!str) return '';
  return normalizeToFullWidth(str).toLowerCase();
}

/**
 * Search campaigns by keyword(s)
 * Supports multiple keywords separated by spaces (AND logic)
 * Uses pre-built _searchIndex for fast lookups
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {string} keyword - Search keyword(s) separated by spaces
 * @returns {Array} Matching campaigns
 */
function searchByKeyword(campaigns, keyword) {
  if (!keyword || keyword.trim() === '') {
    return campaigns;
  }

  // Normalize the entire input first
  const normalizedInput = normalizeForSearch(keyword.trim());

  // Split by both half-width and full-width spaces to get tokens
  // Full-width space (　) is U+3000
  const tokens = normalizedInput.split(/[\s\u3000]+/).filter(t => t.length > 0);

  if (tokens.length === 0) {
    return campaigns;
  }

  return campaigns.filter(campaign => {
    // Use pre-built search index if available (faster)
    if (campaign._searchIndex) {
      // AND logic: All tokens must be found in the search index
      return tokens.every(token => campaign._searchIndex.includes(token));
    }

    // Fallback to legacy normalization if index not yet built
    const normalizedTitle = [
      campaign.title || '',
      campaign.title_kana_hira || '',
      campaign.title_hira_kana || ''
    ].map(t => normalizeForSearch(t)).join(' ');

    const normalizedKeywords = [
      ...(campaign.keywords || []),
      ...(campaign.keywords_kana_hira || []),
      ...(campaign.keywords_hira_kana || [])
    ].map(kw => normalizeForSearch(kw)).join(' ');
    
    const combinedText = normalizedTitle + ' ' + normalizedKeywords;

    return tokens.every(token => combinedText.includes(token));
  });
}

// ============================================
// Period Search
// ============================================

/**
 * Search campaigns by date range (overlap logic)
 * A campaign matches if ANY overlap exists with the search range
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {Date} searchStart - Search start date
 * @param {Date} searchEnd - Search end date
 * @returns {Array} Matching campaigns
 */
function searchByPeriod(campaigns, searchStart, searchEnd) {
  // If no date criteria, return all
  if (!searchStart && !searchEnd) {
    return campaigns;
  }

  // If only one date provided, use same for both
  const effectiveStart = searchStart || searchEnd;
  const effectiveEnd = searchEnd || searchStart;

  return campaigns.filter(campaign => {
    const campStart = campaign.start;
    // Treat null finish as infinite (far future)
    const campFinish = campaign.finish || new Date(9999, 11, 31);

    // No start date means invalid campaign
    if (!campStart) {
      return false;
    }

    // Check for overlap:
    // campaign.start <= searchEnd AND campaign.finish >= searchStart
    return campStart <= effectiveEnd && campFinish >= effectiveStart;
  });
}

// ============================================
// Genre Filter
// ============================================

/**
 * Filter campaigns by genres (OR logic)
 * Campaign matches if ANY selected genre applies
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {Array} selectedGenres - Selected genre keys ['anime', 'artist', 'media', 'other']
 * @returns {Array} Matching campaigns
 */
function filterByGenres(campaigns, selectedGenres) {
  if (!selectedGenres || selectedGenres.length === 0) {
    return campaigns;
  }

  return campaigns.filter(campaign => {
    // OR logic: match if ANY selected genre applies
    return selectedGenres.some(genre => campaign.genres[genre] === true);
  });
}

// ============================================
// Status Filter
// ============================================

/**
 * Filter campaigns by status (OR logic)
 * 
 * @param {Array} campaigns - Array of campaign objects
 * @param {Array} selectedStatuses - Selected statuses ['実施中', '実施予定', '実施済み']
 * @param {Date} today - Current date
 * @returns {Array} Matching campaigns
 */
function filterByStatus(campaigns, selectedStatuses, today = CampaignUtils.getCurrentJST()) {
  if (!selectedStatuses || selectedStatuses.length === 0) {
    return campaigns;
  }

  return campaigns.filter(campaign => {
    const status = CampaignUtils.getCampaignStatus(campaign, today);
    return selectedStatuses.includes(status);
  });
}

// ============================================
// Combined Search
// ============================================

/**
 * Combined search with all criteria
 * 
 * @param {Object} criteria - Search criteria object
 * @param {string} criteria.keyword - Keyword filter
 * @param {Date} criteria.startDate - Period start date
 * @param {Date} criteria.endDate - Period end date
 * @param {Array} criteria.genres - Selected genre keys
 * @param {Array} criteria.statuses - Selected status values
 * @returns {Promise<Array>} Matching campaigns
 */
async function searchCampaigns(criteria = {}) {
  // Get all campaigns
  let results = await CsvLoader.getCampaigns();

  // Filter by display flag first
  results = results.filter(c => c.display);

  // Apply keyword filter
  if (criteria.keyword) {
    results = searchByKeyword(results, criteria.keyword);
  }

  // Apply period filter
  if (criteria.startDate || criteria.endDate) {
    results = searchByPeriod(results, criteria.startDate, criteria.endDate);
  }

  // Apply genre filter
  if (criteria.genres && criteria.genres.length > 0) {
    results = filterByGenres(results, criteria.genres);
  }

  // Apply status filter
  if (criteria.statuses && criteria.statuses.length > 0) {
    results = filterByStatus(results, criteria.statuses);
  }

  return results;
}

// ============================================
// Exports
// ============================================
window.SearchEngine = {
  normalizeToFullWidth,
  normalizeForSearch,
  searchByKeyword,
  searchByPeriod,
  filterByGenres,
  filterByStatus,
  searchCampaigns
};


// === js/index_top.js ===
/**
 * Main Application Module
 * Handles rendering, search UI integration, and page initialization
 * 
 * @requires csv_loader.js
 * @requires campaign_utils.js
 * @requires search_engine.js
 * @requires Swiper.js
 */

// ============================================
// Configuration
// ============================================
const APP_CONFIG = {
  IMAGE_BASE_URL: 'https://jr-central.pnq-production.com/oshi-tabi/img/top/',
  ARCHIVE_PC_STEP: 12,
  ARCHIVE_SP_STEP: 10,
  PC_BREAKPOINT: 750
};

// Click lock to prevent IntersectionObserver from overriding user clicks
let anchorClickLock = false;

// ============================================
// Utility Functions
// ============================================

/**
 * Escape HTML special characters for safe rendering
 * @param {string} str - String to escape
 * @returns {string} Escaped string
 */
function escapeHtml(str) {
  if (!str) return '';
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

/**
 * Normalize campaign links for card anchors (FB36)
 * - recommend.jr-central.co.jp URLs => /oshi-tabi/... relative path
 * - Other URLs => keep full path and open in new tab
 *
 * @param {string} rawLinkUrl - URL from CSV link_url column
 * @returns {{ href: string, targetAttr: string }} Normalized href and optional target attributes
 */
function resolveCampaignLink(rawLinkUrl) {
  const trimmed = (rawLinkUrl || '').trim();
  if (!trimmed) {
    return { href: '', targetAttr: '' };
  }

  // Keep relative paths unchanged (internal navigation)
  if (trimmed.startsWith('/') || trimmed.startsWith('./') || trimmed.startsWith('../')) {
    return { href: trimmed, targetAttr: '' };
  }

  try {
    const parsedUrl = new URL(trimmed);
    const host = parsedUrl.hostname.toLowerCase();
    const isRecommendDomain = host.includes('recommend.jr-central.co.jp');

    if (isRecommendDomain) {
      const marker = '/oshi-tabi/';
      const markerIndex = parsedUrl.pathname.indexOf(marker);

      let relativePath = parsedUrl.pathname;
      if (markerIndex >= 0) {
        relativePath = parsedUrl.pathname.substring(markerIndex);
      }

      if (parsedUrl.search) {
        relativePath += parsedUrl.search;
      }
      if (parsedUrl.hash) {
        relativePath += parsedUrl.hash;
      }

      return {
        href: relativePath,
        targetAttr: ''
      };
    }

    return {
      href: trimmed,
      targetAttr: ' target="_blank" rel="noopener noreferrer"'
    };
  } catch (error) {
    // If parsing fails, keep original behavior and avoid opening unexpected tabs.
    return {
      href: trimmed,
      targetAttr: CampaignUtils.isExternalUrl(trimmed)
        ? ' target="_blank" rel="noopener noreferrer"'
        : ''
    };
  }
}

/**
 * Navigate to search menu (called from search-nav button)
 * Opens the nav-menu by triggering click on btn-menu
 */
function goToSearch() {
  const btnMenu = document.querySelector('.btn-menu');
  if (btnMenu) {
    btnMenu.click();
  }
}
// Expose to global scope for inline onclick
window.goToSearch = goToSearch;

// ============================================
// Search Nav Visibility Management
// ============================================
const SEARCH_NAV_HIDDEN_KEY = 'searchNavLastAccess';
const SEARCH_NAV_HIDE_DAYS = 30;

function isSearchNavDismissed() {
  const lastAccess = localStorage.getItem(SEARCH_NAV_HIDDEN_KEY);
  if (!lastAccess) return false;
  
  const now = Date.now();
  const diff = now - parseInt(lastAccess, 10);
  const maxDiff = SEARCH_NAV_HIDE_DAYS * 24 * 60 * 60 * 1000;
  
  if (diff > maxDiff) {
    // Over 30 days since last access - reset and show again
    localStorage.removeItem(SEARCH_NAV_HIDDEN_KEY);
    return false;
  }
  
  // Within 30 days since last access - keep hidden and update last access timestamp (rolling)
  localStorage.setItem(SEARCH_NAV_HIDDEN_KEY, now.toString());
  return true;
}

/**
 * Dismiss search-nav (starts the 30-day hidden period)
 */
function dismissSearchNav() {
  localStorage.setItem(SEARCH_NAV_HIDDEN_KEY, Date.now().toString());
}

/**
 * Show/hide search-nav with animation
 */
function toggleSearchNavVisibility(show) {
  const searchNav = document.getElementById('js-search-nav');
  if (!searchNav) return;
  
  if (show && !isSearchNavDismissed()) {
    searchNav.classList.remove('is-hidden');
  } else {
    searchNav.classList.add('is-hidden');
  }
}

/**
 * Initialize search-nav behavior
 */
function initSearchNav() {
  const searchNav = document.getElementById('js-search-nav');
  const closeBtn = searchNav?.querySelector('.search-nav__close');
  const navMenu = document.getElementById('nav-menu');
  
  if (!searchNav) return;
  
  // Check if user dismissed it before - keep hidden
  if (isSearchNavDismissed()) {
    // Already hidden by default CSS class, do nothing
    return;
  }
  
  // User hasn't dismissed - show the nav (remove is-hidden)
  searchNav.classList.remove('is-hidden');
  
  // Close button: dismiss for 3 days
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      dismissSearchNav();
      searchNav.classList.add('is-hidden');
    });
  }
  
  // Watch nav-menu state changes
  if (navMenu) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isMenuOpen = navMenu.classList.contains('is-open');
          toggleSearchNavVisibility(!isMenuOpen);
        }
      });
    });
    observer.observe(navMenu, { attributes: true });
  }
}

// ============================================
// Rendering Functions
// ============================================

/**
 * Render a single campaign card HTML
 * 
 * @param {Object} campaign - Campaign object
 * @param {Date} today - Current date for status calculation
 * @param {boolean} showBadge - Whether to show badge (default: true)
 * @returns {string} HTML string
 */
function renderCampaignCard(campaign, today = CampaignUtils.getCurrentJST(), showBadge = true) {
  const status = CampaignUtils.getCampaignStatus(campaign, today);
  const badge = showBadge ? CampaignUtils.getCampaignBadge(campaign, today) : null;
  const imageUrl = CsvLoader.getImageUrl(campaign.img);

  // Date display
  const dateDisplay = CampaignUtils.formatDateRange(campaign.start, campaign.finish, status);

  // Link handling
  const hasLink = campaign.linkUrl && campaign.linkUrl.trim() !== '';
  const noLinkClass = hasLink ? '' : ' no_link';
  const resolvedLink = hasLink ? resolveCampaignLink(campaign.linkUrl) : { href: '', targetAttr: '' };
  const href = resolvedLink.href;
  const targetAttr = resolvedLink.targetAttr;

  // Badge HTML - always include a placeholder for consistent spacing
  let badgeHtml = '';
  if (badge) {
    badgeHtml = `<div class="badge ${badge.cssClass}">${badge.text}</div>`;
  } else {
    badgeHtml = `<div class="badge-empty">&nbsp;</div>`;
  }

  return `
    <li class="campaign-item${noLinkClass}">
      <a href="${escapeHtml(href)}"${targetAttr} class="campaign-link">
        ${badgeHtml}
        <div class="image-wrapper">
          <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(campaign.title)}" loading="lazy" width="1200" height="1200">
        </div>
        <div class="content-wrapper">
          <p class="title">${escapeHtml(campaign.title)}</p>
          <p class="date">${escapeHtml(dateDisplay)}</p>
        </div>
      </a>
    </li>
  `;
}

/**
 * Render a single section with campaigns
 * 
 * @param {string} gridSelector - Selector for campaign grid
 * @param {string} noDataSelector - Selector for "no campaigns" message
 * @param {Array} campaigns - Array of campaigns
 * @param {Date} today - Current date
 * @param {boolean} showBadge - Whether to show badges (default: true)
 */
function renderSection(gridSelector, noDataSelector, campaigns, today, showBadge = true) {
  const grid = document.querySelector(gridSelector);
  const noData = document.querySelector(noDataSelector);

  if (!grid) {
    console.warn('Grid not found:', gridSelector);
    return;
  }

  if (campaigns.length === 0) {
    grid.innerHTML = '';
    if (noData) noData.style.display = 'block';
  } else {
    if (noData) noData.style.display = 'none';
    grid.innerHTML = campaigns.map(c => renderCampaignCard(c, today, showBadge)).join('');
  }

  // Mark as loaded to hide skeleton placeholders
  grid.classList.add('is-loaded');
}

/**
 * Render all campaign sections
 * 
 * @param {Object} groupedCampaigns - { ongoing, upcoming, ended }
 */
function renderAllSections(groupedCampaigns) {
  const today = CampaignUtils.getCurrentJST();

  // Render ongoing section - WITH badges
  renderSection(
    '#lineup .campaign-grid',
    '#lineup .no-campaign',
    groupedCampaigns.ongoing,
    today,
    true  // showBadge = true
  );

  // Render upcoming section - NO badges (only image, title, date)
  renderSection(
    '#comingsoon .campaign-grid',
    '#comingsoon .no-campaign',
    groupedCampaigns.upcoming,
    today,
    false  // showBadge = false
  );

  // Render archived section - shows 〈期間終了〉 via formatDateRange
  renderSection(
    '#archives .campaign-grid',
    '#archives .no-campaign',
    groupedCampaigns.ended,
    today,
    false  // No badge, just 〈期間終了〉 label
  );

  // Reinitialize archive VIEW MORE
  initArchiveViewMore();

  // Reinitialize anchor buttons visibility
  updateAnchorButtonsVisibility();
}

// ============================================
// Carousel Functions
// ============================================

let swiperInstance = null;

/**
 * Render carousel slides
 * - Fixed slides 1-2 are in HTML (preserved)
 * - Dynamic slides loaded from campaign CSV (ongoing campaigns)
 * - Dynamic slides are inserted BEFORE fixed slides so Fixed 1 lands at position 4+ for active state
 */
async function renderCarousel() {
  try {
    const wrapper = document.querySelector('.swiper-wrapper');
    if (!wrapper) {
      console.warn('Swiper wrapper not found');
      return;
    }

    // Get all campaigns and filter for ongoing ones (for carousel)
    const campaigns = await CsvLoader.getCampaigns();
    const today = CampaignUtils.getCurrentJST();
    
    // Filter: Start ≤ Today ≤ End AND display=1
    const ongoingCampaigns = campaigns.filter(c => {
      if (!c.display) return false;
      const status = CampaignUtils.getCampaignStatus(c, today);
      return status === CampaignUtils.STATUS.ONGOING;
    });

    // Sort: fix=1 first, then by most recent date (descending)
    const sortedCampaigns = CampaignUtils.sortCampaigns(ongoingCampaigns, 'start', false);

    // Get the original fixed slide HTML to duplicate
    const originalFixedSlide = wrapper.querySelector('.fixed-slide');
    const fixedSlideHtml = originalFixedSlide ? originalFixedSlide.outerHTML : '';

    // Remove all existing slides (we'll rebuild from scratch)
    wrapper.innerHTML = '';

    // Build interleaved slides: Fixed → 5 Dynamic → Fixed → 5 Dynamic → ...
    const DYNAMIC_PER_FIXED = 5;
    let slideIndex = 0;
    let dynamicIndex = 0;
    const allSlidesHtml = [];

    // Start with fixed slide at position 0
    if (fixedSlideHtml) {
      allSlidesHtml.push(fixedSlideHtml);
      slideIndex++;
    }

    // Interleave dynamic slides with fixed slides
    while (dynamicIndex < sortedCampaigns.length) {
      // Add up to 5 dynamic slides
      for (let i = 0; i < DYNAMIC_PER_FIXED && dynamicIndex < sortedCampaigns.length; i++) {
        const campaign = sortedCampaigns[dynamicIndex];
        const resolved = resolveCampaignLink(campaign.linkUrl);
        allSlidesHtml.push(`
          <div class="swiper-slide dynamic-slide" data-url="${escapeHtml(resolved.href)}">
            <img src="${CsvLoader.getImageUrl(campaign.img)}" alt="${escapeHtml(campaign.title)}" class="slide-image" loading="eager" width="1200" height="1200">
          </div>
        `);
        dynamicIndex++;
        slideIndex++;
      }

      // Add fixed slide after every 5 dynamic slides (if there are more dynamic slides)
      if (dynamicIndex < sortedCampaigns.length && fixedSlideHtml) {
        allSlidesHtml.push(fixedSlideHtml);
        slideIndex++;
      }
    }

    // Insert all slides at once (complete HTML ready before init)
    wrapper.innerHTML = allSlidesHtml.join('');

    // Wait for DOM to fully render before initializing Swiper
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Initialize Swiper with first slide (fixed slide at index 0)
        initSwiper(0);

        // Re-add click handlers
        addSlideClickHandlers();

        const fixedCount = wrapper.querySelectorAll('.fixed-slide').length;
        const dynamicCount = wrapper.querySelectorAll('.dynamic-slide').length;
        console.log(`Carousel: ${dynamicCount} dynamic slides + ${fixedCount} fixed slides. Total: ${dynamicCount + fixedCount}`);
        
        // Apply external link targets after rendering (catch-all for carousel and lineup)
        applyExternalLinkHandler();
      });
    });
  } catch (error) {
    console.error('Failed to render carousel:', error);
    const wrapper = document.querySelector('.swiper-wrapper');
    if (wrapper) {
      // Keep fixed slides, just log error
      console.warn('Dynamic carousel slides could not be loaded');
    }
  }
}

/**
 * Initialize Swiper carousel
 * @param {number} activeSlideIndex - The index of the slide to activate initially (default: 0)
 */
function initSwiper(activeSlideIndex = 0) {
  // Destroy existing instance if any
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
  }

  // Store the target index for use in the init callback
  const targetSlideIndex = activeSlideIndex;

  swiperInstance = new Swiper('.swiper', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    initialSlide: targetSlideIndex, // Dynamic: start at calculated position
    slidesPerView: 'auto',
    loopedSlides: 8,
    coverflowEffect: {
      rotate: 45,
      stretch: 0,
      depth: 250,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        coverflowEffect: {
          rotate: 40,
          depth: 300,
        },
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        coverflowEffect: {
          rotate: 45,
          depth: 250,
        },
      },
    },
    speed: 600,
    autoplay: {
      delay: 4000, // First slide (fixed) stays 4 seconds
      disableOnInteraction: false,
    },
    observer: true,
    observeParents: true,
    on: {
      init(swiper) {
        // Set initial delay based on first slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const isFixedSlide = activeSlide && activeSlide.classList.contains('fixed-slide');
        swiper.params.autoplay.delay = isFixedSlide ? 4000 : 2000;
        
        // Use setTimeout to ensure DOM is fully updated before sliding
        setTimeout(() => {
          swiper.slideToLoop(targetSlideIndex, 0);
          swiper.autoplay.start();
        }, 50);
      },
      slideChangeTransitionEnd(swiper) {
        // Fixed slides = 4s, dynamic slides = 2s
        // Update delay after transition ends and restart autoplay to apply
        const activeSlide = swiper.slides[swiper.activeIndex];
        const isFixedSlide = activeSlide && activeSlide.classList.contains('fixed-slide');
        const newDelay = isFixedSlide ? 4000 : 2000;
        
        if (swiper.params.autoplay.delay !== newDelay) {
          swiper.params.autoplay.delay = newDelay;
          // Restart autoplay to apply new delay
          swiper.autoplay.stop();
          swiper.autoplay.start();
        }
      },
    },
  });
  
  console.log(`Swiper initialized with activeSlideIndex: ${targetSlideIndex}`);
}

/**
 * Add click handlers to slides
 */
function addSlideClickHandlers() {
  document.querySelectorAll('.swiper-slide').forEach(slide => {
    slide.addEventListener('click', function() {
      // Fixed slides open the about modal
      if (this.classList.contains('fixed-slide')) {
        const aboutModal = document.getElementById('aboutModal');
        if (aboutModal) {
          aboutModal.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      
      // Dynamic slides open their URL
      const url = this.getAttribute('data-url');
      if (url && url.trim() !== '') {
        if (CampaignUtils.isExternalUrl(url)) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = url;
        }
      }
    });
  });
}

/**
 * Automatically detect all links (<a>) in the document 
 * and set target="_blank" if they are external.
 */
function applyExternalLinkHandler() {
  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    if (CampaignUtils.isExternalUrl(href)) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

// Expose to global for potential manual refreshes
window.applyExternalLinkHandler = applyExternalLinkHandler;

// ============================================
// Archive VIEW MORE
// ============================================

let archiveStep = APP_CONFIG.ARCHIVE_PC_STEP;
let archiveVisibleCount = 0;

/**
 * Initialize archive section VIEW MORE functionality
 */
function initArchiveViewMore() {
  const section = document.querySelector('.section-archives');
  if (!section) return;

  const items = Array.from(section.querySelectorAll('.campaign-item'));
  const viewMoreBtn = section.querySelector('#view-more');
  const closeBtn = section.querySelector('#close-btn');
  const currentCountEl = section.querySelector('#current-count');
  const totalCountEl = section.querySelector('#total-count');
  const archivesMore = section.querySelector('.archives-more');

  if (!viewMoreBtn || !closeBtn || !currentCountEl || !totalCountEl) return;

  const getStepCount = () => {
    return window.innerWidth >= APP_CONFIG.PC_BREAKPOINT 
      ? APP_CONFIG.ARCHIVE_PC_STEP 
      : APP_CONFIG.ARCHIVE_SP_STEP;
  };

  // Reset state
  archiveStep = getStepCount();
  archiveVisibleCount = archiveStep;
  const totalCount = items.length;

  // Hide section controls if no items
  if (archivesMore) {
    if (totalCount === 0) {
      archivesMore.style.display = 'none';
      return;
    }
    archivesMore.style.display = 'block';
  }

  totalCountEl.textContent = totalCount;

  // Initial display
  items.forEach((item, index) => {
    item.style.display = index < archiveVisibleCount ? '' : 'none';
  });
  currentCountEl.textContent = Math.min(archiveVisibleCount, totalCount);

  // Initial button states
  closeBtn.classList.add('is-hidden');
  viewMoreBtn.classList.toggle('is-hidden', totalCount <= archiveVisibleCount);

  // Clone buttons to remove old event listeners
  const newViewMoreBtn = viewMoreBtn.cloneNode(true);
  const newCloseBtn = closeBtn.cloneNode(true);
  viewMoreBtn.parentNode.replaceChild(newViewMoreBtn, viewMoreBtn);
  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

  // VIEW MORE click handler
  newViewMoreBtn.addEventListener('click', () => {
    const updatedItems = Array.from(section.querySelectorAll('.campaign-item'));
    const prevVisibleCount = archiveVisibleCount;
    archiveStep = getStepCount();
    archiveVisibleCount += archiveStep;

    updatedItems.forEach((item, index) => {
      if (index < archiveVisibleCount) item.style.display = '';
    });

    currentCountEl.textContent = Math.min(archiveVisibleCount, updatedItems.length);

    // Show CLOSE button
    newCloseBtn.classList.remove('is-hidden');

    // Smooth scroll to newly visible items
    const targetItem = updatedItems[prevVisibleCount];
    if (targetItem) {
      const offset = -80;
      const top = targetItem.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    // Hide VIEW MORE if all items shown
    if (archiveVisibleCount >= updatedItems.length) {
      newViewMoreBtn.classList.add('is-hidden');
    }
  });

  // CLOSE click handler
  newCloseBtn.addEventListener('click', () => {
    const updatedItems = Array.from(section.querySelectorAll('.campaign-item'));

    // Reset to initial count
    archiveStep = getStepCount();
    archiveVisibleCount = archiveStep;

    // Update visibility
    updatedItems.forEach((item, index) => {
      item.style.display = index < archiveVisibleCount ? '' : 'none';
    });

    currentCountEl.textContent = Math.min(archiveVisibleCount, updatedItems.length);

    // Reset button states
    newViewMoreBtn.classList.remove('is-hidden');
    newCloseBtn.classList.add('is-hidden');

    // Scroll to section top
    const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
    const sectionTop = section.offsetTop - headerHeight - 20;
    window.scrollTo({ top: sectionTop, behavior: 'smooth' });
  });
}

// ============================================
// Anchor Buttons
// ============================================

/**
 * Update visibility of anchor buttons based on section content
 * Note: Anchor buttons are always kept visible per user request
 */
function updateAnchorButtonsVisibility() {
  // Anchor buttons are now always visible and clickable
  // This function is kept for potential future use but does nothing
}

// ============================================
// Search Integration
// ============================================

/**
 * Get selected genres from tag buttons
 * @returns {Array} Array of genre keys
 */
function getSelectedGenres() {
  const selected = [];
  document.querySelectorAll('.tag-btn.selected').forEach(btn => {
    const value = btn.getAttribute('data-value');
    if (value) selected.push(value);
  });
  return selected;
}

/**
 * Parse date from calendar input field
 * Returns { start, end } dates
 */
function getCalendarDates() {
  // Calendar dates are stored in global variables by the calendar logic
  if (typeof calendarStartDate !== 'undefined' && typeof calendarEndDate !== 'undefined') {
    return {
      start: calendarStartDate,
      end: calendarEndDate
    };
  }
  return { start: null, end: null };
}

/**
 * Execute search with current criteria
 */
async function executeSearch() {
  const keyword = document.getElementById('search-keyword')?.value || '';
  const genres = getSelectedGenres();
  const calDates = getCalendarDates();

  const criteria = {};
  
  if (keyword.trim()) {
    criteria.keyword = keyword;
  }
  
  if (genres.length > 0) {
    criteria.genres = genres;
  }
  
  if (calDates.start) {
    criteria.startDate = calDates.start;
  }
  
  if (calDates.end) {
    criteria.endDate = calDates.end;
  }

  console.log('Executing search with criteria:', criteria);

  try {
    const results = await SearchEngine.searchCampaigns(criteria);
    const grouped = CampaignUtils.groupByStatus(results);
    renderAllSections(grouped);
    
    console.log(`Found ${results.length} campaigns matching criteria`);

    // Auto-scroll to Section 2 (#lineup) after search
    const section2 = document.querySelector('#lineup');
    if (section2) {
      const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
      setTimeout(() => {
        window.scrollTo({
          top: section2.offsetTop - headerHeight - 20,
          behavior: 'smooth'
        });
      }, 100);
    }
  } catch (error) {
    console.error('Search failed:', error);
  }

  // Update search conditions UI after search
  updateSearchConditionsUI();
}

/**
 * Reset search and show all campaigns
 */
async function resetSearch() {
  try {
    const campaigns = await CsvLoader.getCampaigns();
    const grouped = CampaignUtils.groupByStatus(campaigns);
    renderAllSections(grouped);
  } catch (error) {
    console.error('Reset failed:', error);
  }

  // Clear search conditions UI
  updateSearchConditionsUI();
}

// ============================================
// Search Conditions Display
// ============================================

// Genre label mapping
const GENRE_LABELS = {
  'anime': 'アニメ・漫画/小説・ゲーム・YouTuber/VTuber',
  'artist': 'アーティスト・アイドル',
  'other': 'その他'
};

/**
 * Get current search criteria from form inputs
 */
function getCurrentSearchCriteria() {
  const keyword = document.getElementById('search-keyword')?.value?.trim() || '';
  const genres = getSelectedGenres();
  const calDates = getCalendarDates();
  
  return {
    keyword,
    genres,
    startDate: calDates.start,
    endDate: calDates.end
  };
}

/**
 * Format date for display (YYYY/M/D format)
 */
function formatDateForDisplay(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
}

/**
 * Create a condition tag element
 */
function createConditionTag(text, type, value) {
  const tag = document.createElement('span');
  tag.className = 'condition-tag';
  tag.dataset.type = type;
  if (value) tag.dataset.value = value;
  
  tag.innerHTML = `
    ${escapeHtml(text)}
    <button class="remove-btn" type="button" aria-label="削除">✕</button>
  `;
  
  // Handle remove button click
  tag.querySelector('.remove-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    removeCondition(type, value);
  });
  
  return tag;
}

/**
 * Remove a specific condition and re-execute search
 */
function removeCondition(type, value) {
  switch (type) {
    case 'keyword':
      const keywordInput = document.getElementById('search-keyword');
      if (keywordInput) keywordInput.value = '';
      break;
      
    case 'date':
      // Clear calendar dates
      calendarStartDate = null;
      calendarEndDate = null;
      const dateInput = document.getElementById('search-date');
      if (dateInput) dateInput.value = '';
      break;
      
    case 'genre':
      // Deselect specific genre button
      const genreBtn = document.querySelector(`.tag-btn[data-value="${value}"]`);
      if (genreBtn) genreBtn.classList.remove('selected');
      break;
  }
  
  // Update submit button state
  updateSubmitButtonState();
  
  // Check if any criteria remain
  const criteria = getCurrentSearchCriteria();
  const hasCriteria = criteria.keyword || criteria.genres.length > 0 || criteria.startDate || criteria.endDate;
  
  if (hasCriteria) {
    // Re-execute search with remaining criteria
    executeSearch();
  } else {
    // No criteria left, reset to show all
    clearAllConditions();
  }
}

/**
 * Clear all search conditions
 */
async function clearAllConditions() {
  // Clear keyword
  const keywordInput = document.getElementById('search-keyword');
  if (keywordInput) keywordInput.value = '';
  
  // Clear calendar
  calendarStartDate = null;
  calendarEndDate = null;
  const dateInput = document.getElementById('search-date');
  if (dateInput) dateInput.value = '';
  
  // Deselect all genres
  document.querySelectorAll('.tag-btn.selected').forEach(btn => {
    btn.classList.remove('selected');
  });
  
  // Update submit button state
  updateSubmitButtonState();
  
  // Reset search to show all campaigns
  await resetSearch();
  
  // Close menu if open
  closeMenu();
}

/**
 * Update the search conditions UI bar
 */
function updateSearchConditionsUI() {
  const container = document.getElementById('js-search-conditions');
  const tagsContainer = container?.querySelector('.condition-tags');
  
  if (!container || !tagsContainer) return;
  
  // Get current criteria
  const criteria = getCurrentSearchCriteria();
  
  // Clear existing tags
  tagsContainer.innerHTML = '';
  
  // Track if we have any conditions
  let hasConditions = false;
  
  // Add keyword tag
  if (criteria.keyword) {
    tagsContainer.appendChild(createConditionTag(criteria.keyword, 'keyword'));
    hasConditions = true;
  }
  
  // Add date range tag
  if (criteria.startDate || criteria.endDate) {
    let dateText = '';
    if (criteria.startDate && criteria.endDate) {
      dateText = `${formatDateForDisplay(criteria.startDate)} - ${formatDateForDisplay(criteria.endDate)}`;
    } else if (criteria.startDate) {
      dateText = `${formatDateForDisplay(criteria.startDate)} -`;
    } else if (criteria.endDate) {
      dateText = `- ${formatDateForDisplay(criteria.endDate)}`;
    }
    tagsContainer.appendChild(createConditionTag(dateText, 'date'));
    hasConditions = true;
  }
  
  // Add genre tags
  criteria.genres.forEach(genre => {
    const label = GENRE_LABELS[genre] || genre;
    tagsContainer.appendChild(createConditionTag(label, 'genre', genre));
    hasConditions = true;
  });
  
  // Show/hide the conditions bar
  if (hasConditions) {
    container.classList.add('is-visible');
  } else {
    container.classList.remove('is-visible');
  }
}

/**
 * Update submit button enabled/disabled state
 */
function updateSubmitButtonState() {
  const submitBtn = document.getElementById('submit-btn');
  if (!submitBtn) return;
  
  const criteria = getCurrentSearchCriteria();
  const hasCriteria = criteria.keyword || criteria.genres.length > 0 || criteria.startDate || criteria.endDate;
  
  if (hasCriteria) {
    submitBtn.disabled = false;
    submitBtn.classList.add('is-active');
  } else {
    submitBtn.disabled = true;
    submitBtn.classList.remove('is-active');
  }
}

/**
 * Initialize search conditions event handlers
 */
function initSearchConditions() {
  const clearBtn = document.getElementById('js-condition-clear');
  if (clearBtn) {
    clearBtn.addEventListener('click', clearAllConditions);
  }
  
  // Initial state - hide conditions bar
  updateSearchConditionsUI();
}

// ============================================
// Menu Functions
// ============================================

/**
 * Close the navigation menu
 */
function closeMenu() {
  const spNavMenu = document.getElementById('nav-menu');
  const iconMenu = document.querySelector('.icon-menu');
  
  if (spNavMenu && spNavMenu.classList.contains('is-open')) {
    spNavMenu.classList.remove('is-open');
    if (iconMenu) {
      const currentSrc = iconMenu.getAttribute('src');
      iconMenu.setAttribute('src', currentSrc.replace('icon-close.webp', 'icon-menu.webp'));
    }
  }
}

// ============================================
// Initialization
// ============================================

/**
 * Initialize the application
 */
async function initApp() {
  console.log('Initializing Oshi-Tabi app...');

  try {
    // Load and render carousel from CSV
    await renderCarousel();

    // Load and render campaigns from CSV
    const campaigns = await CsvLoader.getCampaigns();
    const grouped = CampaignUtils.groupByStatus(campaigns);
    renderAllSections(grouped);

    console.log('App initialization complete');
  } catch (error) {
    console.error('App initialization failed:', error);
    
    // Show error message in campaign grids
    const errorHtml = '<div class="no-campaign" style="display:block; padding: 20px;">データの読み込みに失敗しました。<br>ページを再読み込みしてください。</div>';
    ['lineup', 'comingsoon', 'archives'].forEach(id => {
      const container = document.querySelector(`#${id} .campaign-grid`);
      if (container) container.innerHTML = errorHtml;
    });
  }
}

// ============================================
// Global Variables for Calendar (bridge)
// ============================================
// These will be set by the calendar logic in the DOMContentLoaded handler
let calendarStartDate = null;
let calendarEndDate = null;

// ============================================
// DOMContentLoaded Handler
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  // Initialize search conditions display
  initSearchConditions();

  // Apply external link targets for static content
  applyExternalLinkHandler();

  // Load holidays immediately
  CsvLoader.getHolidays().then(data => {
    holidaysData = data;
    if (typeof renderCalendar === 'function') renderCalendar();
  });

  // Menu Toggle Logic
  const btnMenu = document.querySelector('.btn-menu');
  const spNavMenu = document.getElementById('nav-menu');
  const iconMenu = document.querySelector('.icon-menu');

  if (btnMenu && spNavMenu && iconMenu) {
    btnMenu.addEventListener('click', () => {
      spNavMenu.classList.toggle('is-open');
      const currentSrc = iconMenu.getAttribute('src');
      if (spNavMenu.classList.contains('is-open')) {
        iconMenu.setAttribute('src', currentSrc.replace('icon-menu.webp', 'icon-close.webp'));
      } else {
        iconMenu.setAttribute('src', currentSrc.replace('icon-close.webp', 'icon-menu.webp'));
      }
    });
  }

  // --- Form Variables ---
  const inputKeyword = document.getElementById('search-keyword');
  const inputDate = document.getElementById('search-date');
  const tagBtns = document.querySelectorAll('.tag-btn');
  const submitBtn = document.getElementById('submit-btn');
  const clearBtn = document.getElementById('clear-btn');

  // --- Form Status Check ---
  function checkFormStatus() {
    const hasKeyword = inputKeyword && inputKeyword.value.trim() !== '';
    const hasDate = inputDate && inputDate.value.trim() !== '' && inputDate.value !== '指定しない';
    const hasTags = document.querySelectorAll('.tag-btn.selected').length > 0;
    
    if (hasKeyword || hasDate || hasTags) {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.add('is-active');
        submitBtn.textContent = '検索結果を表示する';
      }
    } else {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.remove('is-active');
        submitBtn.textContent = 'この条件で検索する';
      }
    }
  }

  // --- Event Listeners ---
  
  // Keyword input
  if (inputKeyword) {
    inputKeyword.addEventListener('input', checkFormStatus);
  }

  // Tag selection
  tagBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('selected');
      checkFormStatus();
    });
  });

  // Clear button
  if (clearBtn) {
    clearBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      
      // Reset keyword
      if (inputKeyword) inputKeyword.value = '';
      
      // Reset calendar
      calendarStartDate = null;
      calendarEndDate = null;
      if (inputDate) inputDate.value = '';
      if (typeof renderCalendar === 'function') renderCalendar();
      
      // Reset tags
      tagBtns.forEach(btn => btn.classList.remove('selected'));
      
      checkFormStatus();
      
      // Reset search results
      await resetSearch();
    });
  }

  // Submit button - Execute search
  if (submitBtn) {
    submitBtn.addEventListener('click', async () => {
      if (!submitBtn.disabled) {
        await executeSearch();
        closeMenu();
      }
    });
  }

  // Enter key support for search form (PC)
  if (inputKeyword) {
    inputKeyword.addEventListener('keydown', async (e) => {
      if (e.key === 'Enter' && submitBtn && !submitBtn.disabled) {
        e.preventDefault();
        await executeSearch();
        closeMenu();
      }
    });
  }

  // ==========================================
  // Calendar Logic
  // ==========================================
  // ==========================================
  // Calendar Logic
  // ==========================================
  let currentDate = CampaignUtils.getCurrentJST();
  let holidaysData = {}; // Stores loaded holidays

  const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月',
    '7月', '8月', '9月', '10月', '11月', '12月'];

  const calendarContainer = document.getElementById('calendarContainer');
  const calendarDays = document.getElementById('calendarDays');
  const monthYearDisplay = document.getElementById('monthYear');
  const rangeDisplay = document.getElementById('selectedRange');

  // Calendar toggle
  if (inputDate) {
    inputDate.addEventListener('click', () => {
      if (calendarContainer && !calendarContainer.classList.contains('show')) {
        calendarContainer.classList.add('show');
        calendarContainer.style.display = 'block';
        renderCalendar();
        setTimeout(() => {
          calendarContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      } else if (calendarContainer) {
        closeCalendar();
      }
    });
  }

  function closeCalendar() {
    if (calendarContainer) {
      calendarContainer.classList.remove('show');
      calendarContainer.style.display = 'none';
    }
  }

  // Calendar cancel
  const calCancel = document.getElementById('calCancel');
  if (calCancel) {
    calCancel.addEventListener('click', () => {
      calendarStartDate = null;
      calendarEndDate = null;
      renderCalendar();
      if (inputDate) inputDate.value = '';
      checkFormStatus();
      closeCalendar();
    });
  }

  // Calendar done
  const calDone = document.getElementById('calDone');
  if (calDone) {
    calDone.addEventListener('click', () => {
      if (calendarStartDate && calendarEndDate) {
        inputDate.value = ` ${formatDateForDisplay(calendarStartDate)} - ${formatDateForDisplay(calendarEndDate)}`;
        checkFormStatus();
        closeCalendar();
      } else {
        alert('開始日と終了日の両方を選択してください');
      }
    });
  }

  // Enter key support for calendar (PC) and search
  document.addEventListener('keydown', async (e) => {
    if (e.key === 'Enter') {
      // If calendar is open, confirm date selection
      if (calendarContainer && calendarContainer.classList.contains('show')) {
        e.preventDefault();
        if (calDone) calDone.click();
      } 
      // Otherwise, if nav menu is open, trigger search
      else if (document.getElementById('nav-menu')?.classList.contains('is-open')) {
        if (submitBtn && !submitBtn.disabled) {
          e.preventDefault();
          await executeSearch();
          closeMenu();
        }
      }
    }
  });

  // Month navigation
  const prevMonth = document.getElementById('prevMonth');
  const nextMonth = document.getElementById('nextMonth');
  
  if (prevMonth) {
    prevMonth.addEventListener('click', () => {
      currentDate.setMonth(currentDate.getMonth() - 1);
      renderCalendar();
    });
  }
  
  if (nextMonth) {
    nextMonth.addEventListener('click', () => {
      currentDate.setMonth(currentDate.getMonth() + 1);
      renderCalendar();
    });
  }

  // Calendar rendering
  function renderCalendar() {
    if (!calendarDays || !monthYearDisplay) return;
    
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    monthYearDisplay.textContent = `${year}年 ${monthNames[month]}`;

    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();
    const prevLastDate = new Date(year, month, 0).getDate();

    calendarDays.innerHTML = '';

    // Previous month days
    for (let i = firstDay - 1; i >= 0; i--) {
      const day = document.createElement('button');
      day.className = 'day other-month';
      day.textContent = prevLastDate - i;
      calendarDays.appendChild(day);
    }

    // Current month days
    for (let i = 1; i <= lastDate; i++) {
      const day = document.createElement('button');
      day.className = 'day';
      day.textContent = i;
      const date = new Date(year, month, i);
      const dateKey = `${year}/${month + 1}/${i}`;
      const holidayName = holidaysData[dateKey];
      const dayOfWeek = date.getDay();
      const isSunday = dayOfWeek === 0;
      const isSaturday = dayOfWeek === 6;

      // Holiday & Weekend Styling
      if (holidayName) {
        day.classList.add('holiday');
        day.setAttribute('title', holidayName);
        day.setAttribute('data-holiday', holidayName);
      } else if (isSunday) {
        day.classList.add('holiday'); // Sunday is Red (Same as holiday)
      } else if (isSaturday) {
        day.classList.add('saturday'); // Blue
      }

      day.addEventListener('click', () => selectDate(date));
      
      // Highlight selected range
      if (calendarStartDate && calendarEndDate) {
        if (date >= calendarStartDate && date <= calendarEndDate) {
          if (date.getTime() === calendarStartDate.getTime() && date.getTime() === calendarEndDate.getTime()) {
            day.classList.add('selected', 'single-select');
          } else if (date.getTime() === calendarStartDate.getTime()) {
            day.classList.add('selected', 'range-start');
          } else if (date.getTime() === calendarEndDate.getTime()) {
            day.classList.add('selected', 'range-end');
          } else {
            day.classList.add('in-range');
          }
        }
      } else if (calendarStartDate && date.getTime() === calendarStartDate.getTime()) {
        day.classList.add('selected', 'single-select');
      }

      calendarDays.appendChild(day);
    }
    updateSelectedRange();
  }

  function selectDate(date) {
    if (!calendarStartDate || (calendarStartDate && calendarEndDate)) {
      calendarStartDate = date;
      calendarEndDate = null;
    } else {
      if (date < calendarStartDate) {
        calendarEndDate = calendarStartDate;
        calendarStartDate = date;
      } else {
        calendarEndDate = date;
      }
    }
    renderCalendar();
  }

  function updateSelectedRange() {
    if (!rangeDisplay) return;
    
    if (calendarStartDate && calendarEndDate) {
      rangeDisplay.innerHTML = `<strong>選択期間:</strong> ${formatDateForDisplay(calendarStartDate)} - ${formatDateForDisplay(calendarEndDate)}`;
    } else if (calendarStartDate) {
      rangeDisplay.innerHTML = `<strong>開始日:</strong> ${formatDateForDisplay(calendarStartDate)} (終了日を選択してください)`;
    } else {
      rangeDisplay.innerHTML = '期間を選択してください';
    }
  }

  function formatDateForDisplay(date) {
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  }

  // Initialize calendar
  renderCalendar();

  // Make renderCalendar available globally for clear button
  window.renderCalendar = renderCalendar;
});

// ==========================================
// Window Load Handler - Initialize App
// ==========================================
window.addEventListener('load', () => {
  initApp();
});

// ==========================================
// Status Button Toggle (Anchor Buttons)
// ==========================================
// NOTE: Toggle logic moved to Smooth Scroll handler below for unified click handling

// ==========================================
// Footer Observer — SP repositioning
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.footer_container');
  const ankerEl = document.querySelector('.campaign-anker');

  if (footer && ankerEl) {
    new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const isSP = window.innerWidth < 768;
          if (!isSP) return;

          if (entry.isIntersecting) {
            // Footer visible on SP: move container to right
            ankerEl.style.left = '20.4px';
            //ankerEl.style.right = '11px';
            ankerEl.style.transform = 'none';
          } else {
            // Footer not visible on SP: center container
            ankerEl.style.left = '50%';
            ankerEl.style.right = '';
            ankerEl.style.transform = 'translateX(-50%)';
          }
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0
      }
    ).observe(footer);
  }
});

// ==========================================
// Section Observer for Scroll Highlighting
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const buttons = [...document.querySelectorAll('.campaign-anker-btn')]
    .filter(btn => !btn.dataset.disabled && btn.style.display !== 'none');

  const sections = buttons.map(btn => {
    const href = btn.getAttribute('href');
    return href ? document.querySelector(href) : null;
  }).filter(Boolean);

  if (sections.length === 0) return;

  const sectionObserver = new IntersectionObserver(
    entries => {
      // Skip if click lock is active (user just clicked an anchor)
      if (anchorClickLock) return;

      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const targetSection = entry.target;
        const activeIndex = sections.indexOf(targetSection);

        if (activeIndex !== -1) {
          buttons.forEach(btn => btn.classList.remove('is-active'));
          buttons[activeIndex].classList.add('is-active');
        }
      });
    },
    {
      rootMargin: '-45% 0px -45% 0px',
      threshold: 0
    }
  );

  sections.forEach(section => sectionObserver.observe(section));
});

// ==========================================
// Campaign Group & PageTop Visibility Control
// ==========================================
// campaign-group: show when scroll > 100px AND footer NOT in view
//                 hide at top (<100px) and at bottom (footer visible)
// btn_pagetop:    show when scrolled > 200px (both mobile & PC)
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.footer_container');
  const campaignGroup = document.querySelector('.campaign-group');
  const btnPagetop = document.querySelector('.btn_pagetop');

  // Track footer visibility state
  let isFooterInView = false;

  // --- Combined visibility update for campaign-group ---
  function updateCampaignGroupVisibility() {
    if (!campaignGroup) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Show: scrolled past 100px AND footer not visible
    if (scrollTop > 100 && !isFooterInView) {
      campaignGroup.classList.add('is-visible');
    } else {
      campaignGroup.classList.remove('is-visible');
    }
  }

  // --- btn_pagetop: show/hide based on scroll position ---
  function checkPagetopVisibility() {
    if (!btnPagetop) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 200) {
      btnPagetop.classList.add('is-visible');
    } else {
      btnPagetop.classList.remove('is-visible');
    }
  }

  // Scroll listener for both elements
  function onScroll() {
    updateCampaignGroupVisibility();
    checkPagetopVisibility();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // initial check

  // --- Footer IntersectionObserver: track footer visibility ---
  if (footer) {
    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        isFooterInView = entry.isIntersecting;
        updateCampaignGroupVisibility();
      });
    }, { threshold: 0 }).observe(footer);
  }

  // Initialize search-nav visibility
  initSearchNav();
});

// ==========================================
// Modal Logic
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('aboutModal');
  const openTrigger = document.querySelector('.about_oshi-tabi');
  const closeButtons = document.querySelectorAll('.js-modal-close');

  if (!modal || !openTrigger) return;

  openTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  });

  const closeModal = () => {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  closeButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
});

// ==========================================
// Smooth Scroll for Anchor Buttons (with Click Lock)
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.campaign-anker-btn');
  
  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(btn.getAttribute('href'));
      if (!target) return;

      // Set click lock to prevent IntersectionObserver from overriding
      anchorClickLock = true;

      // Force this button to be active
      buttons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      // Scroll to target
      const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
      const offset = window.innerWidth < 768 ? 60 : 8;

      window.scrollTo({
        top: target.offsetTop - headerHeight - offset,
        behavior: 'smooth'
      });

      // Release lock when scroll actually ends (hybrid approach)
      if ('onscrollend' in window) {
        // Modern browsers: use scrollend event
        window.addEventListener('scrollend', () => {
          anchorClickLock = false;
        }, { once: true });
      } else {
        // Fallback: release when scroll stops for 150ms
        let scrollTimeout;
        const releaseOnIdle = () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            anchorClickLock = false;
            window.removeEventListener('scroll', releaseOnIdle);
          }, 150);
        };
        window.addEventListener('scroll', releaseOnIdle);
        // Start the check immediately
        releaseOnIdle();
      }
    });
  });
});


})();
